import { useContext, useEffect, useRef, useCallback } from "react"
import CheckoutHeader from "../../Component/Header/checkoutheader"
import DataContext from "../../Component/context"
import constants from "../../Component/services/constants"
import moment from 'moment';
import DeliveryTimeSlotModal from "./delivery_time_slot_modal"
import { checkOrderProcess } from "../../Component/check_order_process"
import { ApiService } from "../../Component/services/apiServices"
import CartMenuItemsModal from "../../Component/Modals/cart_menu_items"
import AccountHeader from "../../Component/Header/account_header";
const ChooseMealData = () => {
    const contextValues = useContext(DataContext)
    const didMountRef = useRef(true);
    const deliveryAmount = useCallback(() => {
        ApiService.fetchData('/setting-data').then((res) => {
            if (res.status === 'success') {
                const {
                    shipping_amount_tiffin,
                    shipping_amount_free
                } = res.data || {};
                let deliveryAmount = 0;
                //console.log('groupByDays()', groupByDays());

                groupByDays().forEach((itemDay) => {
                    let lunchMealsSum = itemDay.meals
                        .filter((item) => item.product_time === 'lunch')
                        .reduce((sum, item) => sum + (parseFloat(item.product_selling_price) + parseFloat(item.addon_amount)) * Number(item.quantity), 0);

                    let dinnerMealsSum = itemDay.meals
                        .filter((item) => item.product_time === 'dinner')
                        .reduce((sum, item) => sum + (parseFloat(item.product_selling_price) + parseFloat(item.addon_amount)) * Number(item.quantity), 0);

                    //console.log('lunchMealsSum', lunchMealsSum);
                    //console.log('dinnerMealsSum', dinnerMealsSum);
                    if (parseFloat(lunchMealsSum) > 0 && parseFloat(lunchMealsSum) < parseFloat(shipping_amount_free)) {
                        deliveryAmount += shipping_amount_tiffin ? parseFloat(shipping_amount_tiffin) : 0;
                    }
                    if (parseFloat(dinnerMealsSum) > 0 && parseFloat(dinnerMealsSum) < parseFloat(shipping_amount_free)) {
                        deliveryAmount += shipping_amount_tiffin ? parseFloat(shipping_amount_tiffin) : 0;
                    }
                });
                //console.log('deliveryAmount', deliveryAmount);

                //setShippingAmount(deliveryAmount)
            }
        })
    }, []);

    useEffect(() => {
        if (didMountRef.current) {
            deliveryAmount()
        }
        didMountRef.current = false;
    }, [deliveryAmount]);

    const groupByDays = () => {
        const cartSession = localStorage.getItem("CART_SESSION");
        const parsedCartSession = cartSession ? JSON.parse(cartSession) : [];
        const daywisemeals = parsedCartSession.reduce((acc, item) => {
            if (!acc[item.product_selected_date]) {
                acc[item.product_selected_date] = [];
            }
            acc[item.product_selected_date].push(item);
            return acc;
        }, {});

        const groupedArray = Object.keys(daywisemeals).map(day => ({
            day: day,
            meals: daywisemeals[day]
        }));

        groupedArray.sort((a, b) => {
            const dateA = new Date(a.day);
            const dateB = new Date(b.day);
            return dateA - dateB;  // Ascending order
        });
        return groupedArray;
    };

    const updateCartInSession = (updatedCart) => {
        localStorage.removeItem("COUPON_SESSION");
        const couponSession = localStorage.getItem("COUPON_SESSION");
        const parsedCouponSession = couponSession ? JSON.parse(couponSession) : {
            discount_amount: 0.0,
            promo_id: 0,
            promo_code: "",
        };
        contextValues.setSelectedCoupon(parsedCouponSession);
        localStorage.setItem('CART_SESSION', JSON.stringify(updatedCart));
        contextValues.setCartSessionData(updatedCart)
        contextValues.setCartCount(updatedCart.length)
    };

    const cartSummaryRemove = (productSessionId) => {
        const cart = JSON.parse(localStorage.getItem('CART_SESSION')) || [];
        const updatedCart = cart.filter(
            (cartItem) => cartItem.product_sesion_id !== productSessionId
        );
        updateCartInSession(updatedCart);
    };

    const deliveryTimeSlotModal = (item) => {
        contextValues.setCartItemDeliverySlot(item)
        setTimeout(() => {
            contextValues.setToggleDeliveryTimeSlotModal(!contextValues.toggleDeliveryTimeSlotModal)
        }, 300);
    }

    const goToPayment = async () => {
        const validation = await checkOrderProcess(contextValues, 'choose meal');
        if (validation) {
            window.location.href = '/checkout';
        }
    };

    const toggleCartMenuItemsModal = (items) => {
        contextValues.setCartMenuItems(items)
        contextValues.setCartMenuItemsModal(!contextValues.toggleCartMenuItems)
    }

    return (
        <>
            <CheckoutHeader heading={'My Cart'} step={'1'}></CheckoutHeader>
            <div id="appCapsule">
                {contextValues.cartCount > 0 ?
                    <>
                        {/* Cart summary */}
                        {groupByDays() && groupByDays().length > 0 &&
                            groupByDays().map((itemDaya, index) => (
                                <div className={`checkbox`} key={index}>
                                    <div className="checkbox-header mb-20">
                                        <h6 className="mb-0"><i className="ri-calendar-event-line"></i> {itemDaya.day !== '' ? moment(itemDaya.day).format('dddd') : ''}</h6>
                                        <h6 className="mb-0">{contextValues.orderRecieveStatus.charAt(0).toUpperCase() + contextValues.orderRecieveStatus.slice(1)}: {itemDaya.day !== '' ? moment(itemDaya.day).format('DD-MM-YYYY') : ''}</h6>
                                    </div>
                                    <div className="checkbox-body">
                                        {itemDaya.meals?.map((item, index) => (
                                            <div className="checkproduct" key={index}>
                                                <div className="checkproductMedia">
                                                    <img alt="Daadi's Kitchen" src={item?.product_image ? item?.product_image : constants.Default_image}></img>
                                                </div>
                                                <div className="checkproductContent">
                                                    <div className="chkp_header">
                                                        <div className="chkp_header_left">
                                                            <h6 className="mb-1">{item?.product_name}</h6>
                                                            <p className="tx-12 tx-gray mb-0" style={{ lineHeight: '18px' }}>
                                                                {contextValues.orderRecieveStatus === 'delivery' ?
                                                                    <>
                                                                        We deliver your {item.product_time} before{' '}
                                                                        {contextValues.settingData &&
                                                                            (item.product_time === 'lunch'
                                                                                ? '14:00'
                                                                                : '20:00')}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        Pickup your {item.product_time} before{' '}
                                                                        {contextValues.settingData &&
                                                                            (item.product_time === 'lunch'
                                                                                ? '14:00'
                                                                                : '20:00')}
                                                                    </>
                                                                }
                                                            </p>
                                                            <p className="tx-12 tx-gray mb-0" style={{ lineHeight: '18px' }}>
                                                                Qty: {item?.quantity}
                                                            </p>
                                                            {item?.product_type === 1 && <div className="Vdetails" onClick={() => toggleCartMenuItemsModal(item)}>View Details <i class="ri-arrow-right-wide-line"></i></div>}
                                                        </div>
                                                        <div className="chkp_header_right">
                                                            <div className="itemPrice itemPrice_cart">
                                                                {parseFloat(item.product_selling_price) && (
                                                                    <ins className="new-price" style={{ color: '#db2727' }}>
                                                                        ${((parseFloat(item.product_selling_price) + parseFloat(item.addon_amount)) * item?.quantity).toFixed(2)}
                                                                    </ins>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="chkp_footer">
                                                        <div onClick={() => { cartSummaryRemove(item.product_sesion_id) }}>
                                                            <a href="javascript:void(0);" className="checkremove">
                                                                <i className="ri-delete-bin-6-line"></i> Remove
                                                            </a>
                                                        </div>
                                                        <button type="button" className="editbutton" onClick={(e) => deliveryTimeSlotModal(item)}>Change Date & Time</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))
                        }
                        <div className="checkout-footer p-0">
                            <div className="p-15">
                                <button type="button" className="btn btn-full btn-primary btn-lg" onClick={(e) => goToPayment()}>Proceed To Checkout</button>
                            </div>
                        </div>
                    </>
                    :
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className='noimg text-center mt-5'>
                                    <img src='/img/emptycart.png' className='wd-150' alt="Daadi's Kitchen"></img>
                                    <h5>Your Cart is Empty</h5>
                                    <p>It looks like you haven't added any items to your cart yet.Your cart is waiting for items!</p>
                                    <a href='/' className='btn btn-outline-primary btn-md'>Continue Order</a>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            {contextValues.toggleDeliveryTimeSlotModal && <DeliveryTimeSlotModal />}
            {contextValues.toggleCartMenuItems && <CartMenuItemsModal />}
        </>
    )
}
export default ChooseMealData